<div>
    <app-page-breadcrumb pageTitle="Gestión de Empresas" />

    <!-- Top bar -->
    <div class="mb-4 flex justify-end rounded-2xl border border-gray-200 bg-white px-4 py-4 dark:border-gray-800 dark:bg-white/3">
        <button type="button"
            class="inline-flex items-center gap-2 rounded-lg bg-brand-500 px-4 py-2 text-sm font-medium text-white hover:bg-brand-600"
            (click)="openCreate()">
            + Agregar empresa
        </button>
        <button type="button"
            class="ml-2 inline-flex items-center gap-2 rounded-lg bg-gray-200 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-300 dark:bg-white/10 dark:text-gray-300 dark:hover:bg-white/20"
            (click)="loadCompanies()" [disabled]="loadingTable">
            {{ loadingTable ? 'Actualizando…' : 'Actualizar' }}
        </button>
    </div>

    <!-- Table card -->
    <div class="min-h-[60vh] rounded-2xl border border-gray-200 bg-white px-3 py-5 dark:border-gray-800 dark:bg-white/3 xl:px-4 xl:py-5">
        <div class="w-full">
            <div class="rounded-2xl border border-gray-200 bg-white pt-4 dark:border-white/5 dark:bg-white/3">

                <!-- Header + search -->
                <div class="flex flex-col gap-2 px-5 mb-4 sm:flex-row sm:items-center sm:justify-between sm:px-6">
                    <h3 class="text-lg font-semibold text-gray-800 dark:text-white/90">Listado de empresas</h3>
                    <div class="relative">
                        <button class="absolute -translate-y-1/2 left-4 top-1/2" type="button">
                            <svg class="fill-gray-500 dark:fill-gray-400" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M3.04199 9.37381C3.04199 5.87712 5.87735 3.04218 9.37533 3.04218C12.8733 3.04218 15.7087 5.87712 15.7087 9.37381C15.7087 12.8705 12.8733 15.7055 9.37533 15.7055C5.87735 15.7055 3.04199 12.8705 3.04199 9.37381ZM9.37533 1.54218C5.04926 1.54218 1.54199 5.04835 1.54199 9.37381C1.54199 13.6993 5.04926 17.2055 9.37533 17.2055C11.2676 17.2055 13.0032 16.5346 14.3572 15.4178L17.1773 18.2381C17.4702 18.531 17.945 18.5311 18.2379 18.2382C18.5308 17.9453 18.5309 17.4704 18.238 17.1775L15.4182 14.3575C16.5367 13.0035 17.2087 11.2671 17.2087 9.37381C17.2087 5.04835 13.7014 1.54218 9.37533 1.54218Z" fill=""/>
                            </svg>
                        </button>
                        <input type="text" placeholder="Buscar por RUC o razón social…"
                            (input)="setSearchTerm($any($event.target).value)"
                            class="dark:bg-dark-900 h-10.5 w-full rounded-lg border border-gray-300 bg-transparent py-2.5 pl-10.5 pr-4 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 dark:focus:border-brand-800 xl:w-75" />
                    </div>
                </div>

                <!-- Table -->
                <div class="overflow-hidden">
                    <div class="max-w-full px-5 overflow-x-auto sm:px-6">
                        <table class="w-full min-w-full">
                            <thead class="border-gray-100 border-y dark:border-white/5">
                                <tr>
                                    <th class="py-3 font-normal text-gray-500 text-start text-theme-sm dark:text-gray-400 w-[12%]">RUC</th>
                                    <th class="py-3 font-normal text-gray-500 text-start text-theme-sm dark:text-gray-400 w-[25%]">Razón Social</th>
                                    <th class="py-3 font-normal text-gray-500 text-start text-theme-sm dark:text-gray-400 w-[18%]">Nombre Comercial</th>
                                    <th class="py-3 font-normal text-gray-500 text-start text-theme-sm dark:text-gray-400 w-[15%]">Teléfono / Email</th>
                                    <th class="py-3 font-normal text-gray-500 text-start text-theme-sm dark:text-gray-400 w-[10%]">SUNAT</th>
                                    <th class="py-3 font-normal text-gray-500 text-start text-theme-sm dark:text-gray-400 w-[8%]">Estado</th>
                                    <th class="py-3 font-normal text-gray-500 text-start text-theme-sm dark:text-gray-400 w-[8%]">Acciones</th>
                                </tr>
                            </thead>
                            <tbody class="divide-y divide-gray-100 dark:divide-white/5">
                                @if (loadingTable) {
                                <tr>
                                    <td colspan="7" class="py-6 text-center text-sm text-gray-500">Cargando empresas…</td>
                                </tr>
                                } @else if (filteredCompanies.length === 0) {
                                <tr>
                                    <td colspan="7" class="py-6 text-center text-sm text-gray-500">No hay empresas registradas.</td>
                                </tr>
                                } @else {
                                @for (company of currentItems; track company.id) {
                                <tr>
                                    <td class="py-2 text-gray-700 text-theme-sm dark:text-gray-400 font-mono">{{ company.ruc }}</td>
                                    <td class="py-2 text-gray-700 text-theme-sm dark:text-gray-400">{{ company.businessName }}</td>
                                    <td class="py-2 text-gray-700 text-theme-sm dark:text-gray-400">{{ company.tradeName || '—' }}</td>
                                    <td class="py-2 text-gray-700 text-theme-sm dark:text-gray-400">
                                        @if (company.phone) { <span class="block text-xs">{{ company.phone }}</span> }
                                        @if (company.email) { <span class="block text-xs text-gray-400">{{ company.email }}</span> }
                                        @if (!company.phone && !company.email) { — }
                                    </td>
                                    <td class="py-2">
                                        <div class="flex flex-col gap-1 items-start">
                                            @if (company.sunatProduction) {
                                            <span class="inline-block px-1.5 py-0.5 rounded text-xs font-medium bg-green-50 text-green-600 dark:bg-green-900/20 dark:text-green-400">Producción</span>
                                            } @else {
                                            <span class="inline-block px-1.5 py-0.5 rounded text-xs font-medium bg-amber-50 text-amber-600 dark:bg-amber-900/20 dark:text-amber-400">Beta</span>
                                            }
                                            @if (company.sunatCertificateLoaded) {
                                            <span class="inline-block px-1.5 py-0.5 rounded text-xs font-medium bg-blue-50 text-blue-600 dark:bg-blue-900/20 dark:text-blue-400">Cert. cargado</span>
                                            }
                                        </div>
                                    </td>
                                    <td class="py-3">
                                        <app-badge size="sm" [color]="company.status === 1 ? 'success' : 'error'">
                                            {{ company.status === 1 ? 'Activa' : 'Inactiva' }}
                                        </app-badge>
                                    </td>
                                    <td class="py-2">
                                        <div class="inline-flex items-center gap-1.5">
                                            <button type="button"
                                                class="bg-orange-400 hover:bg-orange-500 inline-flex items-center px-2.5 py-2 text-sm font-medium text-white rounded-md"
                                                title="Editar" (click)="openEdit(company)">
                                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M20.8749 2.51272C20.1915 1.8293 19.0835 1.8293 18.4001 2.51272L13.2418 7.67095C12.879 8.03379 12.6511 8.50974 12.5959 9.0199L12.4069 10.7668C12.3824 10.9926 12.4616 11.2173 12.6222 11.3778C12.7827 11.5384 13.0074 11.6176 13.2332 11.5931L14.9801 11.4041C15.4903 11.3489 15.9662 11.121 16.3291 10.7582L21.4873 5.59994C22.1707 4.91652 22.1707 3.80848 21.4873 3.12506L20.8749 2.51272ZM18.5981 4.43601L19.564 5.40191L15.2684 9.69751C15.1474 9.81846 14.9888 9.89443 14.8187 9.91283L13.9984 10.0016L14.0872 9.18126C14.1056 9.01121 14.1815 8.85256 14.3025 8.73161L18.5981 4.43601Z" fill="white"/>
                                                    <path d="M5.5 3.25H15.5411L14.0411 4.75H5.5C5.08579 4.75 4.75 5.08579 4.75 5.5V18.5C4.75 18.9142 5.08579 19.25 5.5 19.25H18.5C18.9142 19.25 19.25 18.9142 19.25 18.5V9.95823L20.75 8.45823V18.5C20.75 19.7426 19.7426 20.75 18.5 20.75H5.5C4.25736 20.75 3.25 19.7426 3.25 18.5V5.5C3.25 4.25736 4.25736 3.25 5.5 3.25Z" fill="white"/>
                                                </svg>
                                            </button>
                                            <button type="button"
                                                [disabled]="togglingStatusId === company.id"
                                                (click)="toggleStatus(company)"
                                                class="inline-flex items-center px-2.5 py-2 text-sm font-medium text-white rounded-md transition-colors disabled:opacity-50"
                                                [class]="company.status === 1 ? 'bg-red-400 hover:bg-red-500' : 'bg-green-500 hover:bg-green-600'"
                                                [title]="company.status === 1 ? 'Inactivar' : 'Activar'">
                                                @if (company.status === 1) {
                                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                                    <path stroke-linecap="round" stroke-linejoin="round" d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636" />
                                                </svg>
                                                } @else {
                                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                                    <path stroke-linecap="round" stroke-linejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                                </svg>
                                                }
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                                }
                                }
                            </tbody>
                        </table>
                    </div>
                </div>

                <!-- Pagination -->
                <div class="px-6 py-4 border-t border-gray-200 dark:border-white/5">
                    <div class="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
                        <div class="flex items-center gap-2">
                            <span class="text-sm text-gray-500 dark:text-gray-400">Mostrar</span>
                            <select
                                class="h-9 rounded-lg border border-gray-300 bg-white px-2 text-sm text-gray-700 focus:border-brand-300 focus:outline-none dark:border-gray-700 dark:bg-gray-900 dark:text-gray-300"
                                (change)="onPageSizeChange(+$any($event.target).value)">
                                @for (opt of pageSizeOptions; track opt) {
                                <option [value]="opt" [selected]="opt === itemsPerPage">{{ opt }}</option>
                                }
                            </select>
                            <span class="text-sm text-gray-500 dark:text-gray-400">registros</span>
                        </div>
                        <div class="flex items-center justify-between sm:justify-end gap-2">
                            <app-button size="sm" variant="outline" (btnClick)="goToPage(currentPage - 1)" [disabled]="currentPage === 1">
                                <svg class="fill-current" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M2.58301 9.99868C2.58272 10.1909 2.65588 10.3833 2.80249 10.53L7.79915 15.5301C8.09194 15.8231 8.56682 15.8233 8.85981 15.5305C9.15281 15.2377 9.15297 14.7629 8.86018 14.4699L5.14009 10.7472L16.6675 10.7472C17.0817 10.7472 17.4175 10.4114 17.4175 9.99715C17.4175 9.58294 17.0817 9.24715 16.6675 9.24715L5.14554 9.24715L8.86017 5.53016C9.15297 5.23717 9.15282 4.7623 8.85983 4.4695C8.56684 4.1767 8.09197 4.17685 7.79917 4.46984L2.84167 9.43049C2.68321 9.568 2.58301 9.77087 2.58301 9.99715C2.58301 9.99766 2.58301 9.99817 2.58301 9.99868Z" fill=""/>
                                </svg>
                                <span class="hidden sm:inline">Anterior</span>
                            </app-button>
                            <span class="block text-sm font-medium text-gray-700 dark:text-gray-400 sm:hidden">
                                Pág. {{ currentPage }} / {{ totalPages }}
                            </span>
                            <ul class="hidden items-center gap-0.5 sm:flex">
                                @for (page of [].constructor(totalPages); track $index; let idx = $index) {
                                <li>
                                    <button (click)="goToPage(idx + 1)"
                                        class="flex h-10 w-10 items-center justify-center rounded-lg text-theme-sm font-medium"
                                        [ngClass]="{
                                            'bg-brand-500 text-white': currentPage === idx + 1,
                                            'text-gray-700 hover:bg-brand-500/8 dark:hover:bg-brand-500 dark:hover:text-white hover:text-brand-500 dark:text-gray-400': currentPage !== idx + 1
                                        }">
                                        {{ idx + 1 }}
                                    </button>
                                </li>
                                }
                            </ul>
                            <app-button size="sm" variant="outline" (btnClick)="goToPage(currentPage + 1)" [disabled]="currentPage === totalPages">
                                <span class="hidden sm:inline">Siguiente</span>
                                <svg class="fill-current" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M17.4175 9.9986C17.4178 10.1909 17.3446 10.3832 17.198 10.53L12.2013 15.5301C11.9085 15.8231 11.4337 15.8233 11.1407 15.5305C10.8477 15.2377 10.8475 14.7629 11.1403 14.4699L14.8604 10.7472L3.33301 10.7472C2.91879 10.7472 2.58301 10.4114 2.58301 9.99715C2.58301 9.58294 2.91879 9.24715 3.33301 9.24715L14.8549 9.24715L11.1403 5.53016C10.8475 5.23717 10.8477 4.7623 11.1407 4.4695C11.4336 4.1767 11.9085 4.17685 12.2013 4.46984L17.1588 9.43049C17.3173 9.568 17.4175 9.77087 17.4175 9.99715C17.4175 9.99763 17.4175 9.99812 17.4175 9.9986Z" fill=""/>
                                </svg>
                            </app-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- MODAL: Crear / Editar empresa -->
<app-modal [isOpen]="showForm" [className]="'max-w-3xl'" (close)="closeForm()">
    <!-- Header -->
    <div class="px-6 pt-6 pb-4 border-b border-gray-100 dark:border-gray-700">
        <h3 class="text-lg font-semibold text-gray-800 dark:text-white/90">
            {{ isEditing ? 'Editar empresa' : 'Nueva empresa' }}
        </h3>
        <p class="text-sm text-gray-500 mt-0.5">
            {{ isEditing ? 'Modifica los datos de la empresa.' : 'Completa los datos para registrar una nueva empresa.' }}
        </p>
    </div>

    <!-- Tabs -->
    <div class="flex border-b border-gray-200 dark:border-gray-700 px-6">
        <button type="button" (click)="activeTab = 'general'"
            class="pb-3 pt-3 px-1 mr-6 text-sm font-medium border-b-2 transition-colors"
            [class]="activeTab === 'general' ? 'border-brand-500 text-brand-600 dark:text-brand-400' : 'border-transparent text-gray-500 hover:text-gray-700 dark:hover:text-gray-300'">
            General
        </button>
        <button type="button" (click)="activeTab = 'sunat'"
            class="pb-3 pt-3 px-1 mr-6 text-sm font-medium border-b-2 transition-colors"
            [class]="activeTab === 'sunat' ? 'border-brand-500 text-brand-600 dark:text-brand-400' : 'border-transparent text-gray-500 hover:text-gray-700 dark:hover:text-gray-300'">
            SUNAT
        </button>
        <button type="button" (click)="activeTab = 'certificate'"
            class="pb-3 pt-3 px-1 text-sm font-medium border-b-2 transition-colors"
            [class]="activeTab === 'certificate' ? 'border-brand-500 text-brand-600 dark:text-brand-400' : 'border-transparent text-gray-500 hover:text-gray-700 dark:hover:text-gray-300'">
            Certificado
        </button>
    </div>

    <!-- Tab content -->
    <div class="px-6 py-5 max-h-[60vh] overflow-y-auto">

        <!-- ── TAB: General ── -->
        @if (activeTab === 'general') {
        <div class="grid grid-cols-1 gap-4 sm:grid-cols-2">

            <div>
                <app-label>RUC *</app-label>
                <app-input-field placeholder="11 dígitos numéricos" [(value)]="ruc" maxlength="11" />
                @if (formSubmitted && !ruc.trim()) {
                <p class="mt-1 text-xs text-red-500">RUC requerido</p>
                } @else if (formSubmitted && ruc.trim() && !/^\d{11}$/.test(ruc.trim())) {
                <p class="mt-1 text-xs text-red-500">Debe tener exactamente 11 dígitos</p>
                }
            </div>

            <div>
                <app-label>Razón Social *</app-label>
                <app-input-field placeholder="Ej: Mi Empresa S.A.C." [(value)]="businessName" />
                @if (formSubmitted && !businessName.trim()) {
                <p class="mt-1 text-xs text-red-500">Razón social requerida</p>
                }
            </div>

            <div>
                <app-label>Nombre Comercial</app-label>
                <app-input-field placeholder="Ej: Mi Empresa" [(value)]="tradeName" />
            </div>

            <div class="sm:col-span-2">
                <app-label>Dirección</app-label>
                <app-input-field placeholder="Av. Principal 123, Lima" [(value)]="address" />
            </div>

            <div>
                <app-label>Ubigeo *</app-label>
                <app-ubigeo-picker [ubigeos]="allUbigeos" [loading]="loadingUbigeos"
                    [value]="ubigeo" (valueChange)="onUbigeoChange($event)"
                    placeholder="Seleccionar ubigeo..."></app-ubigeo-picker>
            </div>

            <div class="sm:col-span-2">
                <app-label>Logo</app-label>
                <p class="text-xs text-gray-400 dark:text-gray-500 mb-1">Recomendado: 3500 × 2500 px (PNG o JPG).</p>
                <div class="flex flex-col gap-2">
                    <input type="file" accept="image/*" (change)="onLogoFileChange($event)"
                        class="block w-full text-sm text-gray-500 dark:text-gray-400 file:mr-3 file:py-1.5 file:px-3 file:rounded-lg file:border-0 file:text-sm file:font-medium file:bg-brand-50 file:text-brand-700 dark:file:bg-brand-900/30 dark:file:text-brand-400 hover:file:bg-brand-100 cursor-pointer" />
                    @if (logoFile) {
                    <p class="text-xs text-gray-500 dark:text-gray-400">{{ logoFile.name }} ({{ (logoFile.size / 1024).toFixed(1) }} KB)</p>
                    }
                    <app-input-field placeholder="O pega una URL de imagen..." [(value)]="logoUrl" />
                    @if (logoUrl && !logoFile) {
                    <img [src]="logoUrl" alt="Logo preview" class="h-12 w-auto object-contain rounded" />
                    }
                </div>
            </div>

            <!-- Divider: Contact -->
            <div class="sm:col-span-2 border-t border-gray-100 dark:border-gray-700 pt-3 mt-1">
                <p class="text-xs font-semibold uppercase tracking-wider text-gray-400 mb-3">Contacto</p>
            </div>

            <div>
                <app-label>Teléfono</app-label>
                <app-input-field placeholder="Ej: 999888777" [(value)]="phone" />
            </div>

            <div>
                <app-label>Correo electrónico</app-label>
                <app-input-field placeholder="Ej: contacto@empresa.com" [(value)]="email" />
            </div>

            <div class="sm:col-span-2">
                <app-label>Sitio web</app-label>
                <app-input-field placeholder="https://empresa.com" [(value)]="website" />
            </div>

        </div>
        }

        <!-- ── TAB: SUNAT ── -->
        @if (activeTab === 'sunat') {
        <div class="grid grid-cols-1 gap-4 sm:grid-cols-2">

            <!-- Config -->
            <p class="sm:col-span-2 text-xs font-semibold uppercase tracking-wider text-gray-400">Configuración</p>

            <div>
                <app-label>Código de establecimiento</app-label>
                <app-input-field placeholder="Ej: 0000" [(value)]="sunatEstablishmentCode" maxlength="10" />
            </div>

            <div>
                <app-label>Cuenta de detracciones</app-label>
                <app-input-field placeholder="Ej: 00-123456-7" [(value)]="sunatDetractionAccount" maxlength="20" />
            </div>

            <!-- Toggles -->
            <div class="flex items-center justify-between p-3 rounded-lg border border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-white/3">
                <div>
                    <p class="text-sm font-medium text-gray-700 dark:text-gray-300">Modo Producción</p>
                    <p class="text-xs text-gray-400">Activa cuando la empresa emite en SUNAT producción</p>
                </div>
                <label class="relative inline-flex items-center cursor-pointer">
                    <input type="checkbox" [(ngModel)]="sunatProduction" class="sr-only peer">
                    <div class="w-11 h-6 bg-gray-200 peer-focus:outline-none rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-0.5 after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-brand-500"></div>
                </label>
            </div>

            <div class="flex items-center justify-between p-3 rounded-lg border border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-white/3">
                <div>
                    <p class="text-sm font-medium text-gray-700 dark:text-gray-300">Ley de Amazonía</p>
                    <p class="text-xs text-gray-400">Empresa acogida al beneficio de Ley Amazónica</p>
                </div>
                <label class="relative inline-flex items-center cursor-pointer">
                    <input type="checkbox" [(ngModel)]="sunatAmazoniaLaw" class="sr-only peer">
                    <div class="w-11 h-6 bg-gray-200 peer-focus:outline-none rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-0.5 after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-green-500"></div>
                </label>
            </div>

            <!-- Ubicación -->
            <div class="sm:col-span-2 border-t border-gray-100 dark:border-gray-700 pt-3 mt-1">
                <p class="text-xs font-semibold uppercase tracking-wider text-gray-400 mb-3">Ubicación SUNAT</p>
            </div>

            <div>
                <app-label>Departamento</app-label>
                <app-input-field [value]="ubigDepartment" [disabled]="true" />
            </div>

            <div>
                <app-label>Provincia</app-label>
                <app-input-field [value]="ubigProvince" [disabled]="true" />
            </div>

            <div>
                <app-label>Distrito</app-label>
                <app-input-field [value]="ubigDistrict" [disabled]="true" />
            </div>

            <!-- Credenciales -->
            <div class="sm:col-span-2 border-t border-gray-100 dark:border-gray-700 pt-3 mt-1">
                <p class="text-xs font-semibold uppercase tracking-wider text-gray-400 mb-3">Credenciales SUNAT</p>
            </div>

            <div>
                <app-label>Usuario secundario</app-label>
                <app-input-field placeholder="Usuario SOL secundario" [(value)]="sunatSecondaryUser" maxlength="50" />
            </div>

            <div>
                <app-label>Contraseña usuario sec. {{ isEditing ? '(dejar en blanco = sin cambios)' : '' }}</app-label>
                <app-input-field type="password" placeholder="Contraseña SOL" [(value)]="sunatSecondaryUserPassword" maxlength="100" />
            </div>

            <div>
                <app-label>ID Guía de Remisión</app-label>
                <app-input-field placeholder="ID guía SUNAT" [(value)]="sunatGuideId" maxlength="50" />
            </div>

            <div>
                <app-label>Contraseña guía {{ isEditing ? '(dejar en blanco = sin cambios)' : '' }}</app-label>
                <app-input-field type="password" placeholder="Contraseña guía" [(value)]="sunatGuidePassword" maxlength="100" />
            </div>

        </div>
        }

        <!-- ── TAB: Certificado ── -->
        @if (activeTab === 'certificate') {
        <div class="space-y-5">

            @if (isEditing && sunatCertificateLoaded !== null) {
            <div class="flex items-center gap-2 p-3 rounded-lg border"
                [class]="sunatCertificateLoaded
                    ? 'border-green-200 bg-green-50 dark:border-green-800 dark:bg-green-900/20'
                    : 'border-gray-200 bg-gray-50 dark:border-gray-700 dark:bg-white/3'">
                @if (sunatCertificateLoaded) {
                <svg class="w-5 h-5 text-green-500 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                </svg>
                <div>
                    <p class="text-sm font-medium text-green-700 dark:text-green-300">Certificado digital cargado</p>
                    <p class="text-xs text-green-600 dark:text-green-400">Sube un nuevo archivo .pfx para reemplazarlo</p>
                </div>
                } @else {
                <svg class="w-5 h-5 text-gray-400 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                </svg>
                <div>
                    <p class="text-sm font-medium text-gray-700 dark:text-gray-300">Sin certificado digital</p>
                    <p class="text-xs text-gray-400">Sube un archivo .pfx para habilitar la facturación electrónica</p>
                </div>
                }
            </div>
            }

            <div>
                <app-label>Archivo PFX / P12 {{ isEditing ? '(opcional — reemplaza el actual)' : '' }}</app-label>
                <div class="mt-1">
                    <label class="flex flex-col items-center justify-center w-full h-28 border-2 border-dashed border-gray-300 dark:border-gray-600 rounded-lg cursor-pointer hover:border-brand-400 dark:hover:border-brand-600 transition-colors">
                        <div class="flex flex-col items-center justify-center py-4">
                            @if (pfxFile) {
                            <svg class="w-8 h-8 text-brand-500 mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="1.5">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                            <p class="text-sm font-medium text-brand-600 dark:text-brand-400">{{ pfxFile.name }}</p>
                            <p class="text-xs text-gray-400">{{ (pfxFile.size / 1024).toFixed(1) }} KB</p>
                            } @else {
                            <svg class="w-8 h-8 text-gray-400 mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="1.5">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5m-13.5-9L12 3m0 0l4.5 4.5M12 3v13.5" />
                            </svg>
                            <p class="text-sm text-gray-500">Haz clic para seleccionar un archivo</p>
                            <p class="text-xs text-gray-400">.pfx, .p12</p>
                            }
                        </div>
                        <input type="file" accept=".pfx,.p12" class="hidden" (change)="onPfxFileChange($event)" />
                    </label>
                </div>
            </div>

            <div>
                <app-label>Contraseña del certificado PFX {{ isEditing ? '(dejar en blanco = sin cambios)' : '' }}</app-label>
                <app-input-field placeholder="Contraseña del archivo .pfx" [(value)]="pfxPassword" />
            </div>

        </div>
        }

    </div>

    <!-- Footer -->
    <div class="flex items-center justify-end gap-3 px-6 pb-6 pt-4 border-t border-gray-100 dark:border-gray-700">
        <button type="button" (click)="closeForm()"
            class="px-4 py-2 text-sm font-medium rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-50 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-gray-800">
            Cancelar
        </button>
        <button type="button" (click)="save()" [disabled]="submitting"
            class="px-4 py-2 text-sm font-medium text-white rounded-lg bg-brand-500 hover:bg-brand-600 disabled:opacity-50">
            {{ submitting ? 'Guardando…' : (isEditing ? 'Guardar cambios' : 'Registrar empresa') }}
        </button>
    </div>
</app-modal>

